module.exports = __webpack_public_path__ + "img/onetit.b30394e1.png";